import { NavLink as RouterLink } from 'react-router-dom'
import { ListItem, MenuItem, useMediaQuery, type MenuItemProps } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { type SetStateAction } from 'react'
import { useSelector } from 'react-redux'
import { LINKS } from '../../../../../utils/constants/links'

interface NavLinkProps extends MenuItemProps {
  path: string
  title: string
  setMobileOpen?: React.Dispatch<SetStateAction<boolean>>
  isNav?: boolean
  disabled?: boolean
}

const NavigationLink: React.FC<NavLinkProps> = ({ path, title, setMobileOpen, isNav, disabled = false }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const mode = useSelector((state: any) => state.modeState)
  return (
    <ListItem
      sx={{
        p: isNav ? '0 3px' : '0 2px',
        width: isMobile ? '100%' : 'auto',
        margin: '0'
      }}
    >
      <MenuItem
        className={`header-menu-item ${title === 'Manage Website' && mode.isWp === true ? 'active' : ''}`}
        sx={{
          borderRadius: isMobile ? '10px' : '35px',
          fontSize: '14px',
          fontWeight: 700,
          width: isMobile ? '100%' : 'auto',
          [theme.breakpoints.down('lg')]: {
            p: '15px 18px'
          }
        }}
        component={RouterLink}
        to={`${mode.isWp === true
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          ? `${path === LINKS.MANAGE_WEBSITE || path[0] !== '/' ? 'javascript: void(0);' : `${process.env.REACT_APP_HOSTNAME}${path}`}`
          : `${path}`
        }`}
        onClick={() => { setMobileOpen?.(false) }}
        disabled={disabled}
      >
        {title}
      </MenuItem>
    </ListItem>
  )
}

export default NavigationLink
